import { render, staticRenderFns } from "./DeductionsPlanDelete.vue?vue&type=template&id=0aee4fd3&scoped=true&"
import script from "./DeductionsPlanDelete.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aee4fd3",
  null
  
)

export default component.exports